import { render, staticRenderFns } from "./CustomerReview.vue?vue&type=template&id=6c1002f7&"
import script from "./CustomerReview.vue?vue&type=script&lang=js&"
export * from "./CustomerReview.vue?vue&type=script&lang=js&"
import style0 from "./CustomerReview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports